import { render } from "./ContractCompanyBlockComponent.vue?vue&type=template&id=8cc69458"
import script from "./ContractCompanyBlockComponent.vue?vue&type=script&lang=js"
export * from "./ContractCompanyBlockComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__